import {inject, Injectable} from '@angular/core';
import {ApiResponse, BaseAppInitService} from "@eclick/core-v2";
import {AppInitResponse} from "../../models/responses/app-init.response";
import {CarService} from "../car/car.service";
import {DealerService} from "../dealer.service";

@Injectable({
  providedIn: 'root'
})
export class AppInitService extends BaseAppInitService<AppInitResponse> {

  carService = inject(CarService);
  dealerService  = inject(DealerService);
  override processData(response: ApiResponse<AppInitResponse>): any {
    if(response.data.cars) {
      this.carService.cars = response.data.cars;
    }
    if(response.data.dealers) {
      this.dealerService.dealers = response.data.dealers;
    }
  }
}
